import { ChangeEvent, FocusEvent } from "react";
import { Controller, get } from "react-hook-form";
import { TextField } from "../../ui";

export interface InputProps {
  name: string;
  label: string;
  mask: (value: string) => string;
  disabled?: boolean;
  methods: any;
  helperText?: string;
  // Corrigido para aceitar input e textarea
  onBlur?: (e: FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  // Props aceitas por compatibilidade (o valor real vem do Controller do RHF)
  value?: any;
  error?: boolean;
  size?: string;
  fullWidth?: boolean;
}

export default function InputMascarado({
  name,
  label,
  mask,
  disabled = false,
  methods,
  helperText,
  onBlur: onBlurProp,
}: InputProps) {
  const handleMask = (value: string) => {
    if (!value || value.length <= 0) return "";
    return mask(value);
  };

  return (
    <Controller
      name={name}
      control={methods.control}
      render={({
        field: { name, onBlur, onChange, ref, value },
        formState: { errors },
      }) => {
        const error = get(errors, name);

        return (
          <TextField
            name={name}
            ref={ref}
            onBlur={(e) => {
              onBlur(); // chama o RHF
              if (onBlurProp) onBlurProp(e); // chama o onBlur passado via props
            }}
            onChange={(e: ChangeEvent<HTMLInputElement>) => {
              const valorDigitado = e.target.value;
              const valorComMascara = handleMask(valorDigitado);
              onChange(valorComMascara);
            }}
            value={handleMask(value)}
            error={!!error}
            disabled={disabled}
            helperText={helperText ?? (error?.message as string)}
            label={label}
          />
        );
      }}
    />
  );
}